import script from "./MobileOperate.vue?vue&type=script&lang=ts&setup=true"
export * from "./MobileOperate.vue?vue&type=script&lang=ts&setup=true"

import "./MobileOperate.vue?vue&type=style&index=0&id=7fdc6c04&lang=scss&scoped=true"

import exportComponent from "/Users/foresight/Desktop/foresight/web/PPTist-tauri/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7fdc6c04"]])

export default __exports__